"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hashStringToInt = hashStringToInt;

/* eslint-disable no-bitwise */
function hashStringToInt(str) {
  var hash = 0;
  var i;
  var chr;

  for (i = 0; i < str.length; i += 1) {
    chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }

  return Math.abs(hash);
}
/* eslint-enable no-bitwise */